import React, { ComponentType } from 'react';
import AutoSizer from './autoSizer';
import { FixedSizeList as List, ListChildComponentProps } from 'react-window';

interface Props {
  children: ComponentType<ListChildComponentProps>;
  itemCount: number;
  itemData?: any;
  /** The list itself, for `scrollToItem` - ctrl+L needs to reach a row. */
  listRef?: React.Ref<List>;
}

/**
 * Inline function child, re-mount on every re-render.
 * https://stackoverflow.com/questions/45895831/react-virtualized-autosizer-masonry-doesnt-render-until-resized
 */
export default function ListWithAutosizer({ children, itemCount, itemData, listRef }: Props) {
  return (
    <AutoSizer>
      {({ height, width }) => (
        <List
          ref={listRef}
          height={height}
          width={width}
          itemCount={itemCount}
          itemSize={26}
          itemData={itemData}
        >
          {children}
        </List>
      )}
    </AutoSizer>
  );
}
